


















































































import { Component } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import IntegrationsActivationEmailsList from '@/componentsV2/templates/IntegrationsActivationEmailsList/IntegrationsActivationEmailsList.vue';
import { BreadcrumbData } from '@/componentsV2/molecules/Breadcrumbs/Breadcrumbs.vue';
import Tag from '@/componentsV2/atoms/Tag/Tag.vue';

import Checkbox from '@/components/Checkbox/Checkbox.vue';
import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';
import ActivationEmailService from '@/api/ActivationEmailService';
import BillingModel from '../Models/BillingModel.vue';

@Component({
  components: {
    Page,
    IntegrationsActivationEmailsList,
    Tag,
    Checkbox
  }
})
export default class ActivationEmailDetail extends BillingModel {
  activationEmailService = new ActivationEmailService();
  enabled = false;
  right = 7;

  get breadcrumbs() {
    const breadcrumbList: BreadcrumbData[] = [
      {
        label: 'Emails',
        path: '/activation-emails'
      },
      {
        label: 'Reward & invite non-member customers after purchase'
      }
    ];

    return breadcrumbList;
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'emailAutomation.detail';
  }

  get previewPosition() {
    return {
      right: `${this.right}%`
    };
  }

  myEventHandler() {
    let right = 7;
    if (window.innerWidth > 1525) {
      right = 9;
      const quantFor = window.innerWidth / 100 - 15;
      for (let i = 0; i < quantFor; i++) {
        right += 2;
      }
    }
    this.right = right;
  }

  handlePreviewEmail() {
    const emailPreviewUrl = '/activation-emails/rewards-invite/preview-email';
    window.open(emailPreviewUrl, '_blank');
  }

  back() {
    this.$router.push('/activation-emails');
  }

  goToRewards() {
    this.$router.push('/coin/loyalty');
  }

  triggerActivation() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        `${this.enabled ? 'disable' : 'enable'}Email`,
        false,
        true,
        true,
        true,
        true
      ),
      {
        nameEmail: 'Reward & Invite',
        onConfirm: async () => {
          try {
            this.$showLoaderWithLocker();
            await this.activationEmailService.putActivationEmailEnabled(
              !this.enabled
            );
          } finally {
            this.enabled = !this.enabled;
            this.$hideLoader();
          }
        }
      }
    );
  }

  async checkEmailActivationStatus() {
    try {
      setTimeout(() => {
        this.$showLoaderWithLocker();
      });
      const { data } = await this.activationEmailService.getActivationEmail();
      this.enabled = data.enabled as boolean;
    } finally {
      this.$hideLoader();
    }
  }

  destroyed() {
    window.removeEventListener('resize', this.myEventHandler);
  }

  created() {
    window.addEventListener('resize', this.myEventHandler);
    this.myEventHandler();
  }

  mounted() {
    this.checkEmailActivationStatus();
  }
}
